


















import 'reflect-metadata'
import { Mixins, Component } from 'vue-property-decorator'
import { PlatformGettersMixin } from '@/store/modules/platform/platform.mixins'

@Component({
    components: {},
})
export default class Metadata extends Mixins(PlatformGettersMixin) {
    toggle = 'active' // active | pending

    typeChange(val: string) {
        this.toggle = val ? 'pending' : 'active'
        this.$emit('toggle', this.toggle)
    }
}
